export default "__VITE_ASSET__Cfs8wM1g__"